import React from 'react';
import { Typography } from '@material-ui/core';
import { PlaceholderBox } from '../styles';

export function ModifiersStep() {
  return (
    <PlaceholderBox>
      <Typography variant="body1">
        Modifiers will be configured here.
      </Typography>
    </PlaceholderBox>
  );
}
